function h(t, e) {
  var n = -1, l = t.length;
  for (e || (e = Array(l)); ++n < l; )
    e[n] = t[n];
  return e;
}
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_copyArray.js
// module id = 911
// module chunks = 67